const topics = [
  {
    no: "壹",
    name: "同台旧怨",
    line: "台上同框、台下错身的旧事，一条条对时间线。",
    count: "收录 22 卷",
    icon: "ri-group-line",
  },
  {
    no: "贰",
    name: "旧访谈出土",
    line: "被删改、被剪辑的早年访谈，找原带对半句。",
    count: "收录 17 卷",
    icon: "ri-video-line",
  },
  {
    no: "叁",
    name: "代言翻车",
    line: "早年应过的承诺与后来撇清的话，摆在一起看。",
    count: "收录 9 卷",
    icon: "ri-price-tag-3-line",
  },
  {
    no: "肆",
    name: "饭圈账册",
    line: "应援、集资与回踩的历史旧账，按粉丝叙事归类。",
    count: "收录 14 卷",
    icon: "ri-hand-heart-line",
  },
  {
    no: "伍",
    name: "黑历史后续",
    line: "旧料被重提之后，当事人与粉丝各自的态度演进。",
    count: "收录 11 卷",
    icon: "ri-history-line",
  },
  {
    no: "陆",
    name: "幕后花絮",
    line: "后台、彩排、散场后的陈年小事，补足正片之外。",
    count: "收录 8 卷",
    icon: "ri-film-line",
  },
];

export default function TopicVolumes() {
  return (
    <section id="topics" className="scroll-mt-4 border-y border-[#e3d7bd] bg-[#f3ead8]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2">
          <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#852f12]">
            <i className="ri-folder-open-line" aria-hidden="true"></i>
            旧账卷宗 · 栏目分卷
          </h4>
          <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-4xl">
            想从哪里开始翻
          </h3>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-[#6f6552]">
            每座分卷收录一类呱呱黑料黑历史与陈年往事，翻完一卷再去下一卷，条理比单篇快讯更完整。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#topics"
              className="group flex flex-col justify-between border border-[#e3d7bd] bg-[#faf5eb] p-6 transition hover:border-[#b1401f]"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="font-display text-3xl font-black text-[#b1401f]/70">{t.no}</span>
                  <span className="flex h-10 w-10 items-center justify-center bg-[#1a160e] text-[#f3ead8]">
                    <i className={`${t.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                </div>
                <h3 className="font-display mt-5 text-xl font-bold text-[#1a160e]">{t.name}</h3>
                <p className="mt-2 text-sm leading-6 text-[#6f6552]">{t.line}</p>
              </div>
              <div className="mt-6 flex items-center justify-between border-t border-[#e3d7bd] pt-3 text-[11px] tracking-widest text-[#978a72]">
                <span>{t.count}</span>
                <span className="flex items-center gap-1 text-[#b1401f] transition group-hover:gap-2">
                  开卷
                  <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}